import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import AdminModal from './AdminModal';
import { adminAPI } from '../services/api';

export default function CardStatusDialog({ cardIds, action, onClose, onChanged }) {
  const { t } = useTranslation();
  const [reason, setReason] = useState('');
  const [preview, setPreview] = useState(null);
  const [result, setResult] = useState(null);
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState('');
  const buttonClass = 'rounded-xl border border-cyan-500 px-4 py-2 font-bold disabled:opacity-40';
  const submit = async (apply) => {
    if (busy) return;
    setBusy(true);
    setError('');
    try {
      const body = { cardIds, action, reason: reason.trim() };
      if (apply) body.expectedStates = preview.candidates.map(({ id, status, userId, updatedAt }) => ({ id, status, userId, updatedAt }));
      const response = await (apply ? adminAPI.changePhysicalCardStatus(body) : adminAPI.previewPhysicalCardStatus(body));
      if (apply) { setResult(response.data.data); onChanged(); }
      else setPreview(response.data.data);
    } catch (e) {
      setError(t('cardStatus.failed'));
      if (apply) { setPreview(null); onChanged(); }
    } finally { setBusy(false); }
  };
  const report = result || preview;
  return <AdminModal open title={`${t('cardStatus.title')} · ${t(`cardStatus.${action}`)}`}
    description={t('cardStatus.unchanged')} onClose={() => !busy && onClose()} size="md"
    footer={<>
      <button className={buttonClass} disabled={busy} onClick={onClose}>{t('cardStatus.close')}</button>
      {!result && <button className={buttonClass} disabled={busy || !reason.trim()} onClick={() => submit(false)}>{t('cardStatus.preview')}</button>}
      {!result && preview && <button className={`${buttonClass} bg-cyan-400 text-slate-950`} disabled={busy || !preview.candidates.length} onClick={() => submit(true)}>{t('cardStatus.apply')}</button>}
    </>}>
    <label className="block font-bold" htmlFor="card-status-reason">{t('cardStatus.reason')}</label>
    <textarea id="card-status-reason" maxLength={200} value={reason} disabled={busy || !!result}
      onChange={e => { setReason(e.target.value); setPreview(null); }}
      className="admin-input mt-2 w-full rounded-xl border border-slate-400/40 p-3" rows={2} />
    {busy && <p role="status">{t('common.loading')}</p>}
    {error && <p role="alert" className="mt-3 text-red-600">{error}</p>}
    {report && <div role="status" className="mt-4 space-y-2">
      <p className="font-bold">{result
        ? t('cardStatus.result', { changed: result.changed.length, skipped: result.skipped.length })
        : t('cardStatus.previewResult', { count: preview.candidates.length, skipped: preview.skipped.length })}</p>
      {!result && <p className="break-words text-sm">{preview.candidates.map(card => card.cardNumber).join(', ')}</p>}
      {report.skipped.map(card => <p key={card.id} className="text-sm">{card.cardNumber || card.id}: {t(`cardStatus.${card.reason}`, { defaultValue: t('cardStatus.failed') })}</p>)}
    </div>}
  </AdminModal>;
}
